import { render, staticRenderFns } from "./FormCollecting.vue?vue&type=template&id=358e9154&scoped=true"
import script from "./FormCollecting.vue?vue&type=script&lang=js"
export * from "./FormCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e9154",
  null
  
)

export default component.exports